import React from "react";
import bannerImage from "../../../assets/images/impact_investment_day_2026_banner.png";

export default function PromoBanner() {
  return (
    <section className="w-full bg-red-600">
      <img
        src={bannerImage}
        alt="Impact Investment Day 2026 - Save the dates 2-3 December 2026, Dhaka, Bangladesh"
        className="w-full h-auto object-contain"
      />
    </section>
  );
}
